import type { ReactNode } from 'react';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import type { CustomerPaymentMethod } from '@models/payments';
import { PaymentProcessors } from '@models/payments';
import { getPaymentMethodBrand, type PaymentMethodBrand } from '@features/customers/helpers';

import { ApplePayIcon } from '@assets/payments/icons/apple-pay-icon';
import { GooglePayIcon } from '@assets/payments/icons/google-pay-icon';
import { MasterCardIcon } from '@assets/payments/icons/mastercard-icon';
import { PaypalIcon } from '@assets/payments/icons/paypal-icon';
import { VisaIcon } from '@assets/payments/icons/visa-icon';

import s from './PaymentMethodChip.module.css';

const BRAND_CHIPS: Record<PaymentMethodBrand, { icon: ReactNode; label: string }> = {
  visa: { icon: <VisaIcon />, label: 'Visa' },
  mastercard: { icon: <MasterCardIcon />, label: 'Mastercard' },
  paypal: { icon: <PaypalIcon />, label: 'PayPal' },
  googlepay: { icon: <GooglePayIcon />, label: 'Google Pay' },
  applepay: { icon: <ApplePayIcon />, label: 'Apple Pay' },
  card: { icon: <CreditCardIcon />, label: 'Card' },
};

type PaymentMethodChipProps = {
  customerPaymentMethod?: CustomerPaymentMethod | null;
  processor?: string;
};

function PaymentMethodChip({ customerPaymentMethod, processor }: PaymentMethodChipProps) {
  let brand: PaymentMethodBrand;
  if (processor?.toLowerCase().includes(PaymentProcessors.PAYPAL)) {
    brand = 'paypal';
  } else if (customerPaymentMethod) {
    brand = getPaymentMethodBrand(customerPaymentMethod);
  } else {
    return <span>N/A</span>;
  }

  const { icon, label } = BRAND_CHIPS[brand];
  return (
    <span className={s.chip}>
      {icon}
      <span>{label}</span>
    </span>
  );
}

export default PaymentMethodChip;
